import { useEffect } from 'react';
import { Modal, Form, Radio, InputNumber, Input, message } from 'antd';
import LoyaltyPoinSettinService from 'services/loyalty_point';

const loyaltyService = new LoyaltyPoinSettinService();

const ManualAdjustModal = ({ open, customer, onClose, onAdjusted }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue({ direction: 'add', point: 1, reason: '' });
    }
  }, [open]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      await loyaltyService.adjustPoints({
        customer_id: customer?.id,
        point: values.point,
        direction: values.direction,
        reason: values.reason,
      });
      message.success('Đã điều chỉnh xu');
      if (onAdjusted) await onAdjusted();
      onClose && onClose();
    } catch (e) {
      if (e?.errorFields) return; // form validation error
      message.error(e?.message || 'Có lỗi xảy ra');
    }
  };

  return (
    <Modal
      title={`Điều chỉnh xu — ${customer?.full_name || ''}`}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okText="Lưu"
      cancelText="Huỷ"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="direction"
          label="Loại điều chỉnh"
          rules={[{ required: true, message: 'Chọn loại điều chỉnh' }]}
        >
          <Radio.Group>
            <Radio value="add">Cộng xu</Radio>
            <Radio value="minus">Trừ xu</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name="point"
          label="Số xu"
          rules={[
            { required: true, message: 'Nhập số xu' },
            {
              validator: (_, v) =>
                v > 0 ? Promise.resolve() : Promise.reject(new Error('Số xu phải lớn hơn 0')),
            },
          ]}
        >
          <InputNumber min={1} step={1} style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item
          name="reason"
          label="Lý do"
          rules={[{ required: true, message: 'Nhập lý do điều chỉnh' }]}
        >
          <Input.TextArea rows={3} maxLength={200} showCount />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ManualAdjustModal;
